module.exports = __webpack_public_path__ + "static/media/mb-banner@2x.aeb48d9e.png";